import {
    Directive,
    ElementRef,
    AfterViewInit,
    OnDestroy,
    Inject,
    PLATFORM_ID,
} from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { PageScrollService } from "ngx-page-scroll-core";
// import { Router } from "@angular/router";

@Directive({
    selector: "[appRichTextRouter]",
})
export class RichTextRouterDirective implements AfterViewInit, OnDestroy {
    private cleanupFns: (() => void)[] = [];
    private isBrowser: boolean;

    constructor(
        private el: ElementRef,
        // private router: Router,
        @Inject(PLATFORM_ID) platformId: Object,
        public pageScrollService: PageScrollService,
        @Inject(DOCUMENT) private document: Document,
        // private location: Location
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngAfterViewInit(): void {
        if (!this.isBrowser) return;

        const anchorTags = this.el.nativeElement.querySelectorAll("a");

        anchorTags.forEach((anchor: HTMLAnchorElement) => {
            const href = anchor.getAttribute("href");

            if (
                !href ||
                !this.isInternalLink(href) ||
                anchor.target === "_blank" ||
                !href.startsWith('#')
            ) {
                return;
            }

            const handler = (event: Event) => {
                event.preventDefault();
                event.stopPropagation();
                try {
                    if (href.startsWith('#')) {
                        const fragment = href.substring(1);
                        this.pageScrollService.scroll({
                            document: this.document,
                            scrollTarget: '#'+fragment,
                            scrollOffset: 200,
                            duration:1,
                        });
                    }
                } catch (err) {
                    console.warn("Invalid URL in Rich Text link:", href);
                }
            };

            anchor.addEventListener("click", handler, { capture: true });

            
            this.cleanupFns.push(() =>
                anchor.removeEventListener("click", handler)
            );
        });
    }

    ngOnDestroy(): void {
        this.cleanupFns.forEach((fn) => fn());
        this.cleanupFns = [];
    }

    private isInternalLink(href: string): boolean {
        try {
            const linkUrl = new URL(href, window.location.origin);
            return linkUrl.hostname === window.location.hostname;
        } catch {
            return false;
        }
    }
}
